<template>
  <Modal :is-open="isOpen" size="md" @close="handleClose">
    <div class="send-certificate-modal__content">
      <HeadingDisplay
        class="send-certificate-modal__heading"
        size="small"
        title="Possui certificação aprovada pela CVM?"
      />
      <BaseText>
        Envie o documento para
        <Link href="mailto:cadastro@warren.com.br">cadastro@warren.com.br</Link>
        para análise e, se aprovado, você será classificado como Pessoa
        Investidora Qualificada.
      </BaseText>
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary label="Entendi" @click="handleClose" />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import {
  HeadingDisplay,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Modal,
  Link
} from '@warrenbrasil/nebraska-web';

defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['close']);

const handleClose = () => {
  emit('close');
};
</script>

<style lang="less" scoped>
.send-certificate-modal {
  &__content {
    text-align: left;
  }

  &__heading {
    margin-bottom: @size-spacing-x600;
  }
}
</style>
